/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components/macro";
import {
  NavLink,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import { Helmet } from "react-helmet-async";
import * as Yup from "yup";
import Loading from "../components/Loading";
import CloseIcon from "@mui/icons-material/Close";
import _, { get } from "lodash";
import { DateTimePicker } from "@mui/lab";
import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Paper as MuiPaper,
  TextField,
  Typography,
  Select,
  MenuItem,
  FormControl,
  FormControlLabel,
  Button,
  Checkbox,
  Alert,
  Snackbar,
  Autocomplete,
  InputAdornment,
  IconButton,
} from "@mui/material";

import { Add as AddIcon } from "@mui/icons-material";
import { spacing } from "@mui/system";
import { Formik } from "formik";
import { connect } from "react-redux";
import axios from "../../CustomAxios";
import swal from "sweetalert";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({
  customerCompanies,
  ApCompanies,
  user,
  missingPermissions,
  auths,
  defaultValues,
  jobPlates,
}) {
  // console.log("default",);
  const [plates, setPlates] = React.useState([{}]);
  const [err, setErr] = useState("");
  const [success, setSuccess] = useState(false);
  const [inventory, setInventory] = useState([]);
  const [customerUsers, setCustomerUsers] = useState([]);
  const [ApUsers, setApUsers] = useState([]);
  const [machines, setMachines] = useState([]);
  const [selectedPlates, setSelectedPlates] = useState([]);
  const [cost, setCost] = useState(0);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();
  const authData = JSON.parse(localStorage.getItem("AuthData"));
  const [plateWarn, setPlateWarn] = useState([{}]);
  const [formChanged, setFormChanged] = useState(false);
  const [jobs, setJobs] = useState([]);
  const { setPreventNavigation } = useOutletContext();
  const categories = [
    "Commercial",
    "Web",
    "Semi-Packaging",
    "Packaging",
    "Other",
  ];

  const [
    selectedCustomerCompanyAddresses,
    setSelectedCustomerCompanyAddresses,
  ] = useState([]);

  const snackRef = useRef(null);
  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const handleClose = () => {
    setState({ ...state, open: false });
  };
  useEffect(() => {
    if (authData?.type === "ap_user") {
      getApUsers(user.ap_company[0]._id);
    }
  }, []);

  const plateHandle = (i, obj) => (e) => {
    let plate = [...plates];
    if (obj === "ap_machine") {
      plate[i][obj] = e.target.value;
    }
    if (obj === "ctp_plate_count") {
      if (plateWarn[i].quantity < e.target.value) {
        let temp = plateWarn;
        temp[i]["alt"] = true;
        setPlateWarn(temp);
      } else {
        let temp = plateWarn;
        temp[i]["alt"] = false;
        setPlateWarn(temp);
      }
    }
    if (obj === "not_to_bill" || obj === "production_rejection") {
      plate[i][obj] = e.target.checked;
    } else {
      if (obj === "gripper") {
        if (e.target.value <= 99.99 && e.target.value >= 0.0) {
          plate[i][obj] = parseFloat(e.target.value);
        }
      } else {
        plate[i][obj] = e.target.value;
      }
    }
    setPlates(plate);
    let selected = [];
    plate.map((pl) => {
      selected.push(pl.plate_id);
    });
    setSelectedPlates(selected);
  };

  const addPlate = () => {
    setPlates((prev) => [...prev, {}]);
  };

  useEffect(() => {
    if (formChanged) {
      const unloadCallback = (event) => {
        event.preventDefault();
        event.returnValue = "";
        return "";
      };

      window.addEventListener("beforeunload", unloadCallback);
      return () => window.removeEventListener("beforeunload", unloadCallback);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formChanged]);

  const totalPrice = () => {
    let totalCost = 0;
    selectedPlates.map((plate, i) => {
      const id = plate;
      inventory.map((inv) => {
        if (inv.plate_id === id) {
          if (plates[i].bake && plates[i].printout && plates[i].quantity) {
            totalCost += parseInt(plates[i].bake) * parseInt(inv.baking_cost);
            totalCost +=
              parseInt(plates[i].printout) * parseInt(inv.print_cost);
            totalCost +=
              parseInt(plates[i].quantity) * parseInt(inv.selling_cost);
          }
        }
      });
    });
    setCost(totalCost);
  };
  useEffect(() => {
    if (inventory.length > 0) {
      setDefaultPlates();
    }
  }, [inventory]);

  const getInventory = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData.type}/customer_company/${companyId}/plate`,
        config,
      );
      if (data.success) {
        let initialInventory = data.data.data;
        setInventory(
          initialInventory.filter(
            (i) =>
              i.deactivated === false &&
              i.plate_id && // must have a valid plate_id
              i.technology?.name && // must have technology name
              i.brand?.name, // must have brand name
          ),
        );
      }
    } catch (e) {
      console.log(e.response.data.message);
    }
  };

  const getApMachines = async (company_id) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      let url = "";
      if (userData.type === "ap_user") {
        url = `/api/v1/ap_user/machine/${company_id}`;
      } else {
        url = `/api/v1/${userData.type}/machine/${company_id}`;
      }
      const { data } = await axios.get(url, config);
      console.log(data);
      if (data.success) {
        const filteredMachines = data.data.filter(
          (m) => m.is_deleted === false,
        );
        setMachines(filteredMachines);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getApUsers = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      let url = "";
      if (userData.type === "ap_user") {
        url = `/api/v1/ap_user/ops?company_id=${companyId}`;
      } else {
        url = `/api/v1/${userData.type}/ap_user?company_id=${companyId}`;
      }
      const { data } = await axios.get(url, config);
      if (data.success) {
        setApUsers(data.data.data);
      }
    } catch (e) {
      console.log(e.response.data.error);
    }
  };

  const getCustomerUsers = async (companyId) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      const { data } = await axios.get(
        `/api/v1/${userData.type}/customer_company_user?company_id=${companyId}`,
        config,
      );
      if (data.success) {
        setCustomerUsers(data.data.data);
      }
      // setLoader(false);
    } catch (e) {
      console.log(e.response.data.error);
    }
  };

  const removePlate = (plateToRemove) => {
    // if (id) {
    //   setSelectedPlates((prev) => [...prev.filter((x) => x !== id)]);
    // }
    // setPlates((prev) => [...prev.slice(0, i), ...prev.slice(i + 1)]);
    const updatedPlates = plates.filter((plate) => plate !== plateToRemove);
    setPlates(updatedPlates);
  };

  const checkInventory = async (i, plate, company_id) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.get(
        `/api/v1/${userData.type}/plate_inventory/plate_detail/${company_id}/${plate}`,
        config,
      );
      if (data.success) {
        let obj = {
          plate_id: plate,
          quantity:
            data.data[0]?.quantity === undefined ? 0 : data.data[0]?.quantity,
          alt: false,
        };
        let warns = [...plateWarn];
        warns[i] = obj;
        setPlateWarn(warns);
      }
    } catch (e) {
      console.log(e.response.data.message);
    }
  };

  const getJobs = async () => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      if (userData?.type === "ap_user" || userData?.type === "super_admin") {
        const { data } = await axios.get(
          `/api/v1/${userData?.type}/jobs?is_table=true`,
          config,
        );
        if (data.success) {
          setJobs(data.data);
        }
      } else {
        if (
          user.user?.customer_company._id !== undefined &&
          user.user !== null
        ) {
          const { data } = await axios.get(
            `/api/v1/${userData?.type}/${user.user?.customer_company._id}/jobs?is_table=true`,
            config,
          );
          if (data.success) {
            setJobs(data.data.data);
          }
        }
      }
    } catch (e) {
      console.log("error in job", e);
    }
  };

  useEffect(() => {
    getJobs();
  }, [plates]);

  const createJob = async (values, resetForm) => {
    for (let i = 0; i < plates.length; i++) {
      if (
        plates[i].not_to_bill === true &&
        (values.instructions === "" || values.instructions === " ")
      ) {
        setErr(`Intructions are required for NTB plates`);
        snackRef.current.click();
        return;
      }
    }

    const platesWithCosts = plates.map((plate) => {
      const inventoryItem = inventory.find(
        (item) => item.plate_id === plate.plate_id,
      );
      return {
        ...plate,
        baking_cost: inventoryItem?.baking_cost || 0,
        print_cost: inventoryItem?.print_cost || 0,
        selling_cost: inventoryItem?.selling_cost || 0,
        total_cost:
          (
            Number(inventoryItem?.baking_cost) +
            Number(inventoryItem?.print_cost) +
            Number(inventoryItem?.selling_cost)
          ).toFixed(2) || 0,
        ap_machine: plate.ap_machine || null,
      };
    });

    // const platesWithMachines = plates.map(plate => ({
    //   ...plate,
    //   ap_machine: plate.ap_machine || null
    // }));
    try {
      setLoader(true);
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };
      const { data } = await axios.post(
        `/api/v1/${userData.type}/jobs`,
        {
          ap_company: values.ap_company,
          ap_company_user: values.ap_company_user,
          customer_company_user: values.customer_company_user,
          customer_company: values.customer_company,
          delivery: values.delivery,
          ap_contact_number: values.ap_contact_number,
          customer_contact_number: values.customer_contact_number,
          docket_by: values.docket_by,
          name: values.name,
          pc_ap: values.pc_ap,
          cut: values.cut,
          open_height: values.open_height,
          open_width: values.open_width,
          page: values.page,
          binding_style: values.binding_style,
          received_date: new Date(values.recieved_date).toISOString(),
          required_date: new Date(values.required_date).toISOString(),
          total_form: _checkLength(values.total_form, 4),
          fb: _checkLength(values.fb, 4),
          sb: _checkLength(values.sb, 4),
          dg: _checkLength(values.dg, 4),
          os: _checkLength(values.os, 4),
          instructions: values.instructions,
          plates: platesWithCosts,
          job_refer: values.job_refer,
          category: values.category,
          ap_machine: values.ap_machine,
        },
        config,
      );
      if (data.success) {
        setLoader(false);
        setSuccess(true);
        setErr("");
        resetForm({ values: "" });
        setPlates([]);
        snackRef.current.click();
        setCost(0);
        navigate("/dashboard/jobs", {
          state: { success: true, message: "Job Created Successfully" },
        });
      }
    } catch (e) {
      setLoader(false);
      setErr(e?.response?.data?.error);
      console.log(e);
      snackRef.current.click();
    }
  };

  const _checkLength = (value, length) => {
    value = value?.toString();
    value = value?.slice(0, length);
    return parseInt(value);
  };

  const setGripper = (id, i) => {
    let gripper;
    inventory.map((plate) => {
      if (plate.plate_id === id) {
        gripper = plate.gripper;
      }
    });
    let plate = [...plates];
    plate[i]["gripper"] = gripper;
    setPlates(plate);
  };
  const setDefaultPlates = async () => {
    let temp = [];
    if (jobPlates !== false) {
      jobPlates.map((element) => {
        const selectedPlate = inventory.find(
          (item) => item.plate_id === element.plate_id,
        );
        const plateNameVal = `${selectedPlate?.height}X${selectedPlate?.width}X${selectedPlate?.thickness}_${selectedPlate?.brand?.name}_${selectedPlate.technology.name}_${selectedPlate.company}`;
        temp.push({
          bake: element.bake,
          ctp_plate_count: element.ctp_plate_count,
          gripper: element.gripper,
          plate_id: element.plate_id,
          printout: element.printout,
          screen: element.screen,
          set: element.set,
          plate_name: plateNameVal,
          ap_machine: element.ap_machine,
        });
      });
      setPlates(temp);
      setLoader(false);
    }
  };
  const getData = async () => {
    setLoader(true);
    await getInventory(defaultValues?.customer_company._id);
    await getCustomerUsers(defaultValues?.customer_company._id);
    await getApUsers(defaultValues?.ap_company._id);
    await getApMachines(defaultValues?.ap_company._id);
    await getJobs();
  };
  useEffect(() => {
    if (defaultValues) {
      getData();
    }
  }, [defaultValues]);
  // console.log("default valuesa are", defaultValues, defaultValues.ap_company.name);

  return (
    <>
      {/* General Details */}
      <Formik
        initialValues={{
          ap_company: defaultValues ? defaultValues.ap_company._id : "",
          ap_company_user: defaultValues
            ? defaultValues.ap_company_user
            : authData?.type === "ap_user"
            ? user?._id
            : "",
          ap_contact_number: defaultValues
            ? defaultValues.ap_company.phone_number
            : "",
          // ap_machine: defaultValues ? defaultValues.ap_machine : "",
          customer_contact_number: defaultValues
            ? defaultValues.customer_company.phone_number
            : "",
          customer_company: defaultValues
            ? defaultValues.customer_company._id
            : "",
          delivery: defaultValues ? defaultValues.delivery : "",
          customer_company_user: defaultValues
            ? defaultValues.customer_company_user
            : "",
          docket_by: defaultValues
            ? defaultValues.docket_details.action_by
            : authData?.type === "ap_user"
            ? user?._id
            : "",
          name: defaultValues ? defaultValues.name : "",
          pc_ap: defaultValues ? defaultValues.pc_ap : "",
          total_form: defaultValues ? defaultValues.total_form : "",
          cut: defaultValues ? defaultValues.cut : "",
          open_height: defaultValues ? defaultValues.open_height : "",
          open_width: defaultValues ? defaultValues.open_width : "",
          page: defaultValues ? defaultValues.page : "",
          binding_style: defaultValues ? defaultValues.binding_style : "",
          required_date: defaultValues
            ? new Date(defaultValues.required_date)
            : "",
          recieved_date: defaultValues
            ? new Date(defaultValues.received_date)
            : "",
          fb: defaultValues ? defaultValues.fb : "",
          sb: defaultValues ? defaultValues.sb : "",
          dg: defaultValues ? defaultValues.dg : "",
          os: defaultValues ? defaultValues.os : "",
          instructions: defaultValues ? defaultValues.instructions : "",
          job_refer: defaultValues ? defaultValues._id : "",
          category: defaultValues ? defaultValues.category : "",
        }}
        validationSchema={Yup.object().shape({
          ap_company: Yup.string().required("AP Company  is required"),
          // ap_company_user: Yup.string().required("AP Company user is required"),
          // ap_contact_number: Yup.string().required(
          //   "AP Company Number is required"
          // ),
          // customer_contact_number: Yup.string().required(
          //   "Customer User Number is required"
          // ),
          // customer_company: Yup.string().required(
          //   "Customer Company is required"
          // ),
          // delivery: Yup.object().required("Address is required"),
          // customer_company_user: Yup.string().required(
          //   "Customer Company user is required"
          // ),
          // docket_by: Yup.string().required("Docket By is required"),
          // name: Yup.string().max(255).required("Job Name is required"),
          // pc_ap: Yup.string().max(255).required("PC/AP is required"),
          // cut: Yup.string().max(255).required("cut is required"),
          // open_height: Yup.string()
          //   .max(255)
          //   .required("open height is required"),
          // open_width: Yup.string().max(255).required("open width is required"),
          // page: Yup.string().required("page is required"),
          // binding_style: Yup.string()
          //   .max(255)
          //   .required("binding style is required"),
          // required_date: Yup.string().required("Delivery Date is required"),
          // recieved_date: Yup.string().required("Recieved date is required"),
          // // total_form: Yup.string()
          // //   .matches(
          // //     /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
          // //     "Total Form should be in range 1 - 3999"
          // //   )
          // //   .required("Total Form is required"),
          // fb: Yup.string().matches(
          //   /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
          //   "F/B should be in range 1 - 3999"
          // ),
          // sb: Yup.string().matches(
          //   /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
          //   "S/B should be in range 1 - 3999"
          // ),
          // dg: Yup.string().matches(
          //   /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
          //   "D/G should be in range 1 - 3999"
          // ),
          // os: Yup.string().matches(
          //   /^[1-3]?[0-9]?[0-9]?[0-9]?$/,
          //   "O/S should be in range 1 - 3999"
          // ),
          // instructions: Yup.string(),
        })}
        onSubmit={async (
          values,
          { setErrors, setStatus, setSubmitting, resetForm },
        ) => {
          try {
            // console.log(plates)
            let plt_error = false;
            plates.map((plt) => {
              if (plt.screen === undefined) {
                console.log("ERRRROROROR");
                setErr(`Screen missing for plate  ${plt.plate_name}`);
                snackRef.current.click();
                plt_error = true;
                return;
              }
              if (plt.set === undefined) {
                setErr(`Set missing for plate  ${plt.plate_name}`);
                snackRef.current.click();
                plt_error = true;

                return;
              }
              if (plt.ctp_plate_count === undefined) {
                setErr(`CTP quantity missing for plate  ${plt.plate_name}`);
                snackRef.current.click();
                plt_error = true;

                return;
              }
              if (plt.bake === undefined) {
                setErr(`Bake quantity missing for plate  ${plt.plate_name}`);
                snackRef.current.click();
                plt_error = true;

                return;
              }
              if (plt.printout === undefined) {
                setErr(`Print quantity missing for plate  ${plt.plate_name}`);
                snackRef.current.click();
                plt_error = true;
                return;
              }
            });
            if (plt_error) {
              return;
            }

            createJob(values, resetForm);
          } catch (error) {
            const message = error.message || "Something went wrong";
            setStatus({ success: false });
            setErrors({ submit: message });
            setSubmitting(false);
          }
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          touched,
          values,
        }) => (
          <>
            <Button
              ref={snackRef}
              style={{ display: "none" }}
              onClick={handleClick({ vertical: "top", horizontal: "center" })}
            >
              Click
            </Button>
            <Snackbar
              anchorOrigin={{ vertical, horizontal }}
              open={open}
              onClose={handleClose}
              key={vertical + horizontal}
            >
              {err ? (
                <Alert mt={2} mb={4} severity="error">
                  {err}
                </Alert>
              ) : success ? (
                <Alert mt={2} mb={4} severity="success">
                  Job Created Successfully
                </Alert>
              ) : null}
            </Snackbar>
            {!loader ? (
              <form noValidate onSubmit={handleSubmit} autoComplete="off">
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} lg={12} md={12}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            General Details
                          </Typography>
                        </Grid>

                        {/* Customer Details */}
                        <Grid item xs={12} md={4} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.customer_company &&
                                errors.customer_company,
                            )}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              onClear={() => alert("cleared")}
                              options={customerCompanies}
                              value={customerCompanies.find(
                                (item) => item._id === values.customer_company,
                              )}
                              onChange={(event, newValue) => {
                                setFieldValue(
                                  "customer_company",
                                  newValue?._id || "",
                                );
                                setFormChanged(true);
                                setPreventNavigation(true);
                                if (newValue) {
                                  let defaultAddress =
                                    newValue.addresses[
                                      newValue.default_address
                                    ];
                                  setFieldValue(
                                    "delivery",
                                    defaultAddress || "",
                                  );

                                  setSelectedCustomerCompanyAddresses(
                                    newValue.addresses,
                                  );

                                  setFieldValue("customer_contact_number", "");
                                  getCustomerUsers(newValue?._id);
                                  getInventory(newValue?._id);
                                } else {
                                  setFieldValue("delivery", null);
                                  setSelectedCustomerCompanyAddresses([]);
                                  setCustomerUsers([]);
                                  setInventory([]);
                                }
                                setPlates([{}]);
                              }}
                              inputValue={values?.customer_company?.name}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.customer_company &&
                                      errors.customer_company,
                                  )}
                                  helperText={
                                    touched.customer_company &&
                                    errors.customer_company
                                  }
                                  label="Customer Company"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.delivery && errors.delivery)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={selectedCustomerCompanyAddresses}
                              // defaultValue={values?.delivery}
                              value={values?.delivery}
                              onChange={(event, newValue) => {
                                setFieldValue("delivery", newValue || "");
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option
                                  ? `${option?.address_line_one}, ${option?.address_line_two}, ${option?.city}, ${option?.state}, ${option?.pincode}, India`
                                  : ""
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.delivery && errors.delivery,
                                  )}
                                  helperText={
                                    touched.delivery && errors.delivery
                                  }
                                  label="Delivery"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.customer_company_user &&
                                errors.customer_company_user,
                            )}
                          >
                            {customerUsers && (
                              <Autocomplete
                                id="combo-box-demo"
                                options={customerUsers}
                                value={customerUsers.find(
                                  (item) =>
                                    item._id === values.customer_company_user,
                                )}
                                onChange={(event, newValue) => {
                                  setFieldValue(
                                    "customer_company_user",
                                    newValue?._id || "",
                                  );

                                  setFieldValue(
                                    "customer_contact_number",
                                    newValue.phone_number || "",
                                  );
                                  setFormChanged(true);
                                  setPreventNavigation(true);
                                  setPlateWarn([{}]);
                                }}
                                inputValue={values?.customer_company_user?.name}
                                onBlur={handleBlur}
                                getOptionLabel={(option) => option?.name || ""}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    size="small"
                                    error={Boolean(
                                      touched.customer_company_user &&
                                        errors.customer_company_user,
                                    )}
                                    helperText={
                                      touched.customer_company_user &&
                                      errors.customer_company_user
                                    }
                                    label="Customer Company User"
                                  />
                                )}
                              />
                            )}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4} lg={3}>
                          <TextField
                            name="customer_contact_number"
                            fullWidth
                            size="small"
                            inputProps={{ readOnly: true }}
                            value={values.customer_contact_number}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.customer_contact_number &&
                                errors.customer_contact_number,
                            )}
                            helperText={
                              touched.ap_contact_number &&
                              errors.ap_contact_number
                            }
                            id="search-field"
                            label="Customer Contact Number"
                          />
                        </Grid>

                        {/* AP Company Details */}
                        <Grid item xs={12} md={4} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.ap_company && errors.ap_company,
                            )}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              // defaultValue={"rutwik"}
                              options={ApCompanies}
                              value={ApCompanies.find(
                                (item) => item._id === values.ap_company,
                              )}
                              onChange={(event, newValue) => {
                                setFieldValue(
                                  "ap_company",
                                  newValue?._id || "",
                                );
                                getApUsers(newValue?._id);
                                getApMachines(newValue?._id);
                                setPlateWarn([{}]);
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              inputValue={values?.ap_company?.name}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.ap_company && errors.ap_company,
                                  )}
                                  helperText={
                                    touched.ap_company && errors.ap_company
                                  }
                                  label="AP Company"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.ap_company_user && errors.ap_company_user,
                            )}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={ApUsers}
                              value={ApUsers.find(
                                (item) => item._id === values.ap_company_user,
                              )}
                              onChange={(event, newValue) => {
                                setFieldValue(
                                  "ap_company_user",
                                  newValue?._id || "",
                                );
                                setFieldValue(
                                  "ap_contact_number",
                                  newValue.phone_number || "",
                                );
                              }}
                              inputValue={values?.ap_company_user?.name}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.ap_company_user &&
                                      errors.ap_company_user,
                                  )}
                                  helperText={
                                    touched.ap_company_user &&
                                    errors.ap_company_user
                                  }
                                  label="AP Company User"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={4} lg={3}>
                          <TextField
                            name="ap_contact_number"
                            fullWidth
                            size="small"
                            inputProps={{ readOnly: true }}
                            value={values.ap_contact_number}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.ap_contact_number &&
                                errors.ap_contact_number,
                            )}
                            helperText={
                              touched.ap_contact_number &&
                              errors.ap_contact_number
                            }
                            id="search-field"
                            label="AP Contact Number"
                          />
                        </Grid>

                        <Grid item xs={12} md={4} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(
                              touched.docket_by && errors.docket_by,
                            )}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={ApUsers}
                              value={ApUsers.find(
                                (item) => item._id === values.docket_by,
                              )}
                              onChange={(event, newValue) => {
                                setFieldValue("docket_by", newValue?._id || "");
                              }}
                              inputValue={values?.docket_by?.name}
                              onBlur={handleBlur}
                              getOptionLabel={(option) => option?.name || ""}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.docket_by && errors.docket_by,
                                  )}
                                  helperText={
                                    touched.docket_by && errors.docket_by
                                  }
                                  label="Docket By"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        {/* Job Details */}
                        <Grid item xs={12} md={3} lg={3}>
                          <TextField
                            fullWidth
                            size="small"
                            data-testid="job_name"
                            name="name"
                            value={values.name}
                            onBlur={handleBlur}
                            error={Boolean(touched.name && errors.name)}
                            helperText={touched.name && errors.name}
                            onChange={(e) => {
                              handleChange("name")(e);
                              setFormChanged(true);
                              setPreventNavigation(true);
                            }}
                            id="search-field"
                            label="Job Name"
                          />
                        </Grid>
                        <Grid item xs={12} md={3} lg={3}>
                          <FormControl
                            fullWidth
                            error={Boolean(touched.category && errors.category)}
                          >
                            <Autocomplete
                              id="combo-box-demo"
                              options={categories}
                              // defaultValue={values?.delivery}
                              value={values?.category}
                              onChange={(event, newValue) => {
                                setFieldValue("category", newValue || "");
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  error={Boolean(
                                    touched.category && errors.category,
                                  )}
                                  helperText={
                                    touched.category && errors.category
                                  }
                                  label="Category"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={3} lg={3}>
                          <FormControl
                            error={Boolean(
                              touched.binding_style && errors.binding_style,
                            )}
                            fullWidth
                          >
                            <Select
                              name="binding_style"
                              id="search-field"
                              size="small"
                              value={values.binding_style}
                              onBlur={handleBlur}
                              onChange={handleChange}
                              displayEmpty
                              inputProps={{ "aria-label": "Without label" }}
                            >
                              <MenuItem value={""} disabled>
                                Select Binding Style
                              </MenuItem>
                              <MenuItem value={"perfect"}>Perfect</MenuItem>
                              <MenuItem value={"center_pinning"}>
                                Center Pining
                              </MenuItem>
                              <MenuItem value={"perfect_section"}>
                                Perfect Section
                              </MenuItem>
                              <MenuItem value={"wiro"}>Wiro</MenuItem>
                              <MenuItem value={"cut_n_go"}>Cut N Go</MenuItem>
                              <MenuItem value={"punch_n_go"}>
                                Punch N Go
                              </MenuItem>
                            </Select>
                            {/* <FormHelperText>
                              Select binding Style
                            </FormHelperText> */}
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} md={6} lg={3}>
                          <TextField
                            name="pc_ap"
                            fullWidth
                            size="small"
                            value={values.pc_ap}
                            onBlur={handleBlur}
                            error={Boolean(touched.pc_ap && errors.pc_ap)}
                            helperText={touched.pc_ap && errors.pc_ap}
                            onChange={handleChange}
                            id="search-field"
                            label="PC-AP"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            size="small"
                            name="total_form"
                            value={values.total_form}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.total_form && errors.total_form,
                            )}
                            helperText={touched.total_form && errors.total_form}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("total_form")(e);
                              }
                            }}
                            id="search-field"
                            label="Total Form"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="open_height"
                            fullWidth
                            size="small"
                            value={values.open_height}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_height && errors.open_height,
                            )}
                            helperText={
                              touched.open_height && errors.open_height
                            }
                            onChange={(e) => {
                              handleChange("open_height")(e);
                              setFormChanged(true);
                              setPreventNavigation(true);
                            }}
                            id="search-field"
                            label="Open-Height"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="open_width"
                            fullWidth
                            size="small"
                            value={values.open_width}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.open_width && errors.open_width,
                            )}
                            helperText={touched.open_width && errors.open_width}
                            onChange={(e) => {
                              handleChange("open_width")(e);
                              setFormChanged(true);
                              setPreventNavigation(true);
                            }}
                            id="search-field"
                            label="Open-Width"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            name="cut"
                            fullWidth
                            size="small"
                            value={values.cut}
                            onBlur={handleBlur}
                            error={Boolean(touched.cut && errors.cut)}
                            helperText={touched.cut && errors.cut}
                            onChange={(e) => {
                              handleChange("cut")(e);
                              setFormChanged(true);
                              setPreventNavigation(true);
                            }}
                            id="search-field"
                            label="Cut"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            size="small"
                            name="page"
                            value={values.page}
                            onBlur={handleBlur}
                            error={Boolean(touched.page && errors.page)}
                            helperText={touched.page && errors.page}
                            onChange={(e) => {
                              handleChange("page")(e);
                              setFormChanged(true);
                              setPreventNavigation(true);
                            }}
                            id="search-field"
                            label="Page"
                          />
                        </Grid>

                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            name="fb"
                            fullWidth
                            size="small"
                            value={values.fb}
                            onBlur={handleBlur}
                            error={Boolean(touched.fb && errors.fb)}
                            helperText={touched.fb && errors.fb}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("fb")(e);
                              }
                            }}
                            id="search-field"
                            label="F/B"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            size="small"
                            name="sb"
                            value={values.sb}
                            onBlur={handleBlur}
                            error={Boolean(touched.sb && errors.sb)}
                            helperText={touched.sb && errors.sb}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("sb")(e);
                              }
                            }}
                            id="search-field"
                            label="S/B"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            size="small"
                            name="dg"
                            value={values.dg}
                            onBlur={handleBlur}
                            error={Boolean(touched.dg && errors.dg)}
                            helperText={touched.dg && errors.dg}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("dg")(e);
                              }
                            }}
                            id="search-field"
                            label="D/G"
                          />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <TextField
                            type="number"
                            onWheel={(e) => e.target.blur()}
                            fullWidth
                            size="small"
                            name="os"
                            value={values.os}
                            onBlur={handleBlur}
                            error={Boolean(touched.os && errors.os)}
                            helperText={touched.os && errors.os}
                            onChange={(e) => {
                              if (
                                (e.target.value <= 9999 &&
                                  e.target.value > 0) ||
                                e.target.value === ""
                              ) {
                                handleChange("os")(e);
                              }
                            }}
                            id="search-field"
                            label="O/S"
                          />
                        </Grid>
                        {/* Refer Job */}
                        <Grid item xs={12} md={6}>
                          <FormControl fullWidth>
                            <Autocomplete
                              options={jobs}
                              value={jobs.find(
                                (item) => item._id === values.job_refer,
                              )}
                              onChange={(event, newValue) => {
                                setFieldValue("job_refer", newValue?._id || "");
                                setFormChanged(true);
                                setPreventNavigation(true);
                              }}
                              onBlur={handleBlur}
                              getOptionLabel={(option) =>
                                option?.job_id + " - " + option?.name
                              }
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  size="small"
                                  label="Referred Job"
                                />
                              )}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <FormControl fullWidth>
                            <DateTimePicker
                              name="recieved_date"
                              renderInput={(props) => (
                                <TextField
                                  size="small"
                                  {...props}
                                  error={
                                    touched.recieved_date &&
                                    errors.recieved_date
                                  }
                                />
                              )}
                              label="Recieved Date"
                              value={values.recieved_date || null}
                              onChange={(newValue) => {
                                let selectedDate = newValue;
                                var month = (
                                  "0" + parseInt(selectedDate?.getMonth() + 1)
                                ).slice(-2);
                                var day = (
                                  "0" + parseInt(selectedDate?.getDate())
                                ).slice(-2);
                                var hour = parseInt(selectedDate.getHours());
                                var minute = parseInt(
                                  selectedDate.getMinutes(),
                                );
                                let date =
                                  selectedDate?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("recieved_date", date);

                                let delivery_temp_date = new Date(
                                  new Date().setHours(
                                    new Date(selectedDate).getHours() + 3,
                                  ),
                                );
                                month = (
                                  "0" +
                                  parseInt(delivery_temp_date?.getMonth() + 1)
                                ).slice(-2);
                                day = (
                                  "0" + parseInt(delivery_temp_date?.getDate())
                                ).slice(-2);
                                hour = parseInt(delivery_temp_date.getHours());
                                minute = parseInt(selectedDate.getMinutes());
                                let updated_date =
                                  delivery_temp_date?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("required_date", updated_date);
                              }}
                              onBlur={handleBlur}
                            />
                          </FormControl>
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                          <FormControl
                            error={Boolean(
                              touched.required_date && errors.required_date,
                            )}
                            fullWidth
                          >
                            <DateTimePicker
                              name="required_date"
                              renderInput={(props) => (
                                <TextField
                                  size="small"
                                  {...props}
                                  error={
                                    touched.required_date &&
                                    errors.required_date
                                  }
                                />
                              )}
                              label="Delivery Date"
                              // defaultValue={
                              //   new Date(
                              //     new Date().setHours(
                              //       new Date(values.recieved_date).getHours() +
                              //         3
                              //     )
                              //   )
                              // }
                              value={values.required_date}
                              onChange={(newValue) => {
                                console.log(
                                  new Date(
                                    new Date().setHours(
                                      new Date(
                                        values.recieved_date,
                                      ).getHours() + 3,
                                    ),
                                  ),
                                  newValue,
                                );
                                let selectedDate = newValue;
                                var month = (
                                  "0" + parseInt(selectedDate?.getMonth() + 1)
                                ).slice(-2);
                                var day = (
                                  "0" + parseInt(selectedDate?.getDate())
                                ).slice(-2);
                                var hour = parseInt(selectedDate.getHours());
                                var minute = parseInt(
                                  selectedDate.getMinutes(),
                                );
                                let date =
                                  selectedDate?.getFullYear() +
                                  "-" +
                                  month +
                                  "-" +
                                  day +
                                  ":" +
                                  hour +
                                  ":" +
                                  minute;
                                setFieldValue("required_date", date);
                              }}
                              onBlur={handleBlur}
                              minDateTime={
                                new Date(
                                  new Date().setHours(
                                    new Date(values.recieved_date).getHours() +
                                      3,
                                  ),
                                )
                              }
                            />
                          </FormControl>
                        </Grid>

                        <Grid item xs={12} lg={8} md={8}>
                          <TextField
                            multiline
                            size="small"
                            name="instructions"
                            fullWidth
                            value={values.instructions}
                            onBlur={handleBlur}
                            error={Boolean(
                              touched.instructions && errors.instructions,
                            )}
                            helperText={
                              touched.instructions && errors.instructions
                            }
                            onChange={handleChange}
                            id="search-field"
                            label="Job Instructions"
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                {/* Plate Details */}
                <Card mb={6}>
                  <CardContent>
                    <Paper elevation={3} style={{ padding: "2%" }}>
                      <Grid container spacing={5}>
                        <Grid item xs={12} lg={12} md={12}>
                          <Typography variant="h6" color="primary" gutterBottom>
                            Plate Details
                          </Typography>
                        </Grid>

                        {plates.map((pl, i) => {
                          const check = [];
                          if (selectedPlates.length) {
                            selectedPlates.map((p) => {
                              check.push(p);
                            });
                          }

                          return (
                            <>
                              <Grid
                                item
                                xs={6}
                                md={4}
                                lg={4}
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <FormControl fullWidth>
                                  <Autocomplete
                                    id="combo-box-demo"
                                    options={inventory}
                                    disableClearable
                                    // value={pl?.plate_name}
                                    onChange={(e, newValue) => {
                                      let plate = [...plates];
                                      plate[i]["plate_id"] = newValue?.plate_id;
                                      const selectedPlate = inventory.find(
                                        (item) =>
                                          item.plate_id === newValue?.plate_id,
                                      );

                                      plate[i][
                                        "plate_name"
                                      ] = `${selectedPlate?.height}X${selectedPlate?.width}X${selectedPlate?.thickness}_${selectedPlate?.brand?.name}_${selectedPlate.technology.name}_${selectedPlate.company}`;
                                      setPlates(plate);
                                      setGripper(newValue?.plate_id, i);
                                      totalPrice();
                                      checkInventory(
                                        i,
                                        newValue?.plate_id,
                                        values.ap_company,
                                      );
                                      setFormChanged(true);
                                      setPreventNavigation(true);
                                    }}
                                    getOptionLabel={(plate) => {
                                      return `${plate?.height}X${plate?.width}X${plate?.thickness}_${plate?.brand?.name}_${plate.technology.name}_${plate.company}`;
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        size="small"
                                        label={
                                          pl.plate_name
                                            ? pl.plate_name
                                            : "Select Plate"
                                        }
                                      />
                                    )}
                                  />
                                </FormControl>
                                <CloseIcon
                                  onClick={() => {
                                    removePlate(pl);
                                  }}
                                  sx={{
                                    height: "100%",
                                    border: "1px solid lightGrey",
                                    borderLeft: 0,
                                    borderRadius: "0 5px 5px 0",
                                    padding: "0 2px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Grid>
                              {/* <Grid item xs={12} md={6} lg={2}>
                                <Autocomplete
                                  size="small"
                                  fullWidth
                                  options={machines}
                                  getOptionLabel={(option) => `${option.name}-${option.serial_no}`}
                                  value={machines.find((m) => m._id === pl.ap_machine) || null}
                                  onChange={(event, newValue) => {
                                    plateHandle(i, "ap_machine")({
                                      target: { value: newValue ? newValue._id : "" }
                                    });
                                  }}
                                  renderInput={(params) => (
                                    <TextField {...params} label="Select Machine" variant="outlined" />
                                  )}
                                />
                              </Grid> */}
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  id="search-field"
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  value={pl.gripper || ""}
                                  onChange={plateHandle(i, "gripper")}
                                  label="Gripper"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type="text"
                                  onWheel={(e) => e.target.blur()}
                                  id="search-field"
                                  value={pl.screen || ""}
                                  onChange={plateHandle(i, "screen")}
                                  label="Screen + Paper"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  id="search-field"
                                  value={pl.set || ""}
                                  onChange={plateHandle(i, "set")}
                                  label="Set"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  id="standard-number"
                                  label="CTP"
                                  value={pl.ctp_plate_count || ""}
                                  color={
                                    plateWarn[i]?.alt === true && "warning"
                                  }
                                  helperText={
                                    plateWarn[i]?.alt === true &&
                                    "Insufficient plates"
                                  }
                                  onChange={plateHandle(i, "ctp_plate_count")}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  m={2}
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  id="standard-number"
                                  label="Bake Quantity"
                                  fullWidth
                                  size="small"
                                  value={pl.bake}
                                  onChange={(e) => {
                                    plateHandle(i, "bake")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  id="standard-number"
                                  label="Printout Quantity"
                                  value={pl.printout || ""}
                                  onChange={(e) => {
                                    plateHandle(i, "printout")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  fullWidth
                                  size="small"
                                />
                              </Grid>
                              <Grid item xs={12} md={6} lg={2}>
                                <TextField
                                  fullWidth
                                  size="small"
                                  id="standard-number"
                                  label="Total Quantity"
                                  disabled
                                  value={pl.quantity || ""}
                                  onChange={(e) => {
                                    plateHandle(i, "quantity")(e);
                                    totalPrice();
                                  }}
                                  type="number"
                                  onWheel={(e) => e.target.blur()}
                                  m={2}
                                />
                              </Grid>
                              <Grid item xs={12} lg={3} md={3}>
                                <FormControl
                                  fullWidth
                                  component="fieldset"
                                  variant="standard"
                                >
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        onChange={plateHandle(i, "not_to_bill")}
                                        checked={pl.not_to_bill || false}
                                      />
                                    }
                                    label={"Not to Bill"}
                                  />
                                </FormControl>
                              </Grid>
                            </>
                          );
                        })}
                        <Grid
                          item
                          xs={12}
                          lg={12}
                          md={12}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Button
                            onClick={addPlate}
                            mr={2}
                            variant="contained"
                            color="primary"
                            disabled={missingPermissions.length > 0}
                          >
                            Add Plate
                            <AddIcon />
                          </Button>
                        </Grid>
                      </Grid>
                    </Paper>
                  </CardContent>
                </Card>

                <Grid item xs={12} lg={12} md={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    disabled={isSubmitting || missingPermissions.length > 0}
                  >
                    Create Job
                  </Button>
                </Grid>
              </form>
            ) : (
              <Loading />
            )}
          </>
        )}
      </Formik>
    </>
  );
}

const getUserCompanies = async (
  setCustomerCompanies,
  setApCompanies,
  setLoader,
) => {
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };
    const apCompany = await axios.get(
      `/api/v1/${userData?.type}/ap_company`,
      config,
    );
    if (apCompany.data.success) {
      setApCompanies(apCompany.data.data.data);
    }
    const customerCompany = await axios.get(
      `/api/v1/${userData.type}/customer_company?limit=${500}`,
      config,
    );
    if (customerCompany.data.success) {
      setCustomerCompanies(
        customerCompany.data.data.data.filter((c) => c.is_deleted === false),
      );
    }
    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e.response.data.error);
  }
};

function CreateJob({ auths }) {
  // console.log("auths is", auths);
  const { job_id } = useParams();
  const [defaultValues, setDefaultValues] = useState(false);
  // const [render,setRender]=useState(false);
  const [jobPlates, setJobPlates] = useState(false);

  const [user, setUser] = useState([]);
  const [loader, setLoader] = useState(true);
  const [ApCompanies, setApCompanies] = useState([]);
  const [customerCompanies, setCustomerCompanies] = useState([]);

  const [missingPermissions, setMissingPermissions] = useState([]);
  let requiredPermissions = [
    "view_customer_company_user_list",
    "view_ap_company_list",
    "view_ap_user_list",
  ];

  useEffect(() => {
    if (auths?.user) {
      setUser(auths.user);
      let userPermissions = auths.user?.role?.permissions;
      if (userPermissions) {
        const missing = _.difference(requiredPermissions, userPermissions);
        setMissingPermissions(missing);
        if (missing.length > 0) {
          swal(
            "",
            `You are unauthorized to complete this action because you do not have the following permissions

            ${_.toUpper(missing.join(", ").replace(/_/g, " "))}
            `,
            "error",
          );
        }
      }
    }
    if (job_id) getJobDetails(job_id, auths?.user?.customer_company?._id);
    getUserCompanies(setCustomerCompanies, setApCompanies, setLoader);
  }, [auths.user]);
  async function getJobDetails(id, company) {
    const authData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + authData?.access_token,
      },
    };
    let url = "";
    if (authData?.type === "customer_user") {
      url = `/api/v1/${authData?.type}/${company}/jobs/${id}`;
    } else {
      url = `/api/v1/${authData?.type}/jobs/${id}`;
    }
    const { data } = await axios.get(url, config);

    // --- START: Duplication adjustments ---
    const modified = { ...data.data };

    // 1. Override dates with current date/time
    modified.received_date = new Date().toISOString();
    modified.required_date = new Date().toISOString();

    // 2. Set empty numeric fields to 0
    const numericFields = ["total_form", "fb", "sb", "dg", "os", "page"];
    numericFields.forEach((field) => {
      if (
        modified[field] === undefined ||
        modified[field] === null ||
        modified[field] === ""
      ) {
        modified[field] = 0;
      }
    });

    // 3. Handle plate-level numeric fields
    if (modified.plates && Array.isArray(modified.plates)) {
      modified.plates = modified.plates.map((plate) => {
        const updated = { ...plate };
        const plateNumeric = [
          "bake",
          "printout",
          "ctp_plate_count",
          "set",
          "gripper",
          "quantity",
        ];
        plateNumeric.forEach((f) => {
          if (
            updated[f] === undefined ||
            updated[f] === null ||
            updated[f] === ""
          ) {
            updated[f] = 0;
          }
        });
        return updated;
      });
    }
    // --- END: Duplication adjustments ---

    setDefaultValues(modified);
    setJobPlates(modified.plates);
  }
  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              CREATE JOB
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/jobs">
                All Jobs
              </Link>
              <Typography>Create Job</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {/* <GeneralDetails /> */}
            <FormDetails
              missingPermissions={missingPermissions}
              customerCompanies={customerCompanies}
              ApCompanies={ApCompanies}
              user={user}
              auths={auths}
              defaultValues={defaultValues}
              jobPlates={jobPlates}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, null)(CreateJob);
